/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProjectPhaseFragmentDoc } from '../../projects/ProjectPhasesConfigurator.generated.js';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../attachments/Attachments.generated.js';
import { PhoneFragmentDoc, CrmContactPersonFragmentDoc } from '../../../auth/UserDataProvider.generated.js';
import { ProjectContactLinksFragmentDoc, QuoteItemContactLinksFragmentDoc } from '../../projects/boxes/ProjectOverviewContactsBox.generated.js';
export type OpportunityListItemFragment = { __typename: 'Project', id: string, number: string, type?: Types.ProjectType | null, categories: Array<string>, viewerPermissions: Array<Types.PermissionName>, title: string, deadline?: any | null, earliestStart?: any | null, earliestPlanSessionDate?: any | null, createdAt?: any | null, overdue: boolean, state: Types.ProjectStateMachineStatus, leadId?: number | null, urgent: boolean, quotingStatus: Types.QuotingStatus, phase: { __typename: 'OrganisationProjectPhase', id: string, name: string, applicableForState: Types.ProjectStateMachineStatus, color: string }, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } | null, buildingInfo?: { __typename: 'BuildingInfo', id: string, buildingAddress?: { __typename: 'Address', streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, plannedUsers: Array<{ __typename: 'User', id: string, firstname: string, familyname: string } | null>, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null } | null, crmLinks: Array<{ __typename: 'ProjectLinkCrmOrganisation', id: string, linkAs: string, crmOrganisation: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } | { __typename: 'ProjectLinkCrmUser', id: string, linkAs: string, crmUser: { __typename: 'CrmPerson', id: string, fullname: string, firstname: string, familyname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, crmCompany: { __typename: 'CrmCompany', id: string } } }>, budget?: { __typename: 'Money', currency: string, amount: number } | null };

export const OpportunityListItemFragmentDoc = gql`
    fragment OpportunityListItem on Project {
  id
  number
  type
  categories
  viewerPermissions
  title
  deadline
  earliestStart
  earliestPlanSessionDate
  createdAt
  overdue
  state
  phase {
    id
    ...ProjectPhase
  }
  leadId
  urgent
  assignee {
    id
    user {
      id
      firstname
      familyname
      fullname
      avatar {
        ...AttachmentSnapshot
      }
    }
  }
  quotingStatus
  viewerPermissions
  buildingInfo {
    id
    buildingAddress {
      streetLines1
      city
      postalCode
      countryCode
      location {
        lat
        lng
      }
    }
  }
  plannedUsers {
    id
    firstname
    familyname
  }
  crmOrganisation {
    id
    title
    email
    phones {
      id
      ...Phone
    }
    contactPerson {
      id
      ...CrmContactPerson
    }
  }
  crmLinks {
    ...ProjectContactLinks
  }
  budget {
    currency
    amount
  }
}
    ${ProjectPhaseFragmentDoc}
${AttachmentSnapshotFragmentDoc}
${PhoneFragmentDoc}
${CrmContactPersonFragmentDoc}
${ProjectContactLinksFragmentDoc}`;